import { Comment } from "../../src/components/insta/interfaces";
import Game from "../../src/shell/Game";
import { alex } from "../characters/Alex";
import { ann } from "../characters/Ann";
import { mc } from "../characters/MC";

export function getAnnComments(imageKey: string) {

    if (imageKey === "Ann4" && Game.seenScenarios.includes(`V5AnnMovie`)) {
        annComments["Ann4"] = [...annComments["Ann4"],
        {
            name: alex.properties.instaNickName,
            message: "I was so happy to see you!!! Muah! 😍😍😍"
        }
        ];
    }
    return annComments;
}
const annComments: { [key: string]: (Comment)[]; } = {
    "Ann28": [
        {
            name: ann.properties.instaNickName,
            message: `He always picks the best movies 😁`,
        },
        {
            name: `Dr.Pancakes`,
            message: `Is that your boyfriend? If so you clould do better.`
        },
        {
            name: `Prowl`,
            message: `Isn't that the bartender that hits on everything with a pulse?`
        },
        {
            name: `JeanB`,
            message: `Whoever that is, he seems to be more interested in the movie then you.... No movie would take my attention from you.`
        },
        {
            name: `ddos`,
            message: `that moment when she tries to kiss you after sucking your dick.`
        },
        {
            name: `sarcasmo`,
            message: `that thousand yard stare suggests you did some surprise butt stuff to him.`
        },
        {
            name: `dinesh`,
            message: `muuuuua 😘  i amm kis u on boobie and pusy. 😝`
        },
        {
            name: `shah`,
            message: `hello dear. how big is ur pussy`
        },
        {
            name: `Mr.Sox`,
            message: `It looks like your boyfriend didn't get the happy ending he was hoping for.`
        },
        {
            name: `Simptastic`,
            message: `I know lots of great movies if you're interested. 🤓`
        },
        {
            name: `Explorer`,
            message: `your titty and nipple looks so inviting. I would play with them all day 😋`
        },
        {
            name: `Pounder`,
            message: `I also got best movie here. It's called "I was tight yesterday". We could watch it and then put it into practice 😏`
        },
        {
            name: `Arthur`,
            message: `sarcasmo, dinesh, shah, Explorer... stop that! She is so adorable, why do you write such nasty stuff about her??? She is nice person and should be treated with respect! Ann pay no attention to them. If you would like I would watch some thrilling movie with you. The Little Mermaid looks great, would you be interested?`
        },
        {
            name: `Arthur`,
            message: `just don't bring that guy with you....ok? please? 🥹`
        }, {
            name: `shah`,
            message: `arthur u saying wat u son of basterd bich?`
        },
        {
            name: `Arthur`,
            message: `shah you are a rude person, why are you even here looking at my Ann? 🤨`
        },
        {
            name: `murad`,
            message: `damn, the sheer number of simps here. Girl, you should start milking them for cash (if they have any)`
        },
        {
            name: `shah`,
            message: `arthur u saying wat u son of basterd bich?`
        },
        {
            name: `Arthur`,
            message: `shah you are a rude person, why are you even here looking at my Ann? 🤨`
        },
        {
            name: `murad`,
            message: `damn, the sheer number of simps here. Girl, you should start milking them for cash (if they have any)`
        },
        {
            name: `shah`,
            message: `arthur i wil be husband of Ann and mak her call me daddy, i wil put my lulla in her vagina u little shit`
        },
        {
            name: `Arthur`,
            message: `shah more like NAH! Ann would never be with brute like you. She needs someone who would pamper her, support her. Someone who can see her for who she truly is... Something you could never understand.`
        },
        {
            name: `McManmaan`,
            message: `Dat ya man? Drop the zero, and get with the hero! 🦸‍♂️`
        },
        {
            name: `tern`,
            message: `hold up a minute, have I not seen that guy somewhere before? I seem to remember him working in a bar or something around here, that right?`
        },
        {
            name: `BendadickCumperbatch`,
            message: `You guys got room for 1 more?`
        },

    ],
    "Ann26": [
        {
            name: ann.properties.instaNickName,
            message: `Good morning! 😊`,
        },
        {
            name: `CorprealFale`,
            message: `Good Morning pretty!`
        },
        {
            name: `Adar`,
            message: `@${alex.properties.instaNickName} , we see you.`
        },
        {
            name: `Suricat`,
            message: `A good morning indeed`
        },
        {
            name: `The_Crooked_Rooster`,
            message: `@${alex.properties.instaNickName} This doesn't count as a team up photo, but we'll take it.`
        },
        {
            name: `Prowl`,
            message: `No morning is good until I get your good morning kisses.`
        },
        {
            name: `Tern`,
            message: `It would have been a great morning if it was me taking the picture and not Alex.`
        },

    ],
    "Ann25": [
        {
            name: ann.properties.instaNickName,
            message: `Bored...`,
        },
        {
            name: `CorprealFale`,
            message: `I know something we could do !`
        },
        {
            name: `Dr.Pancakes`,
            message: `@${alex.properties.instaNickName}  I think if we work together we can find a way to entertain her. What you say?`
        },
        {
            name: `getoutofmylab`,
            message: `you uh... you should be careful where you point that thing. May get accused of holding a Weapon of Ass Destruction.`
        },
        {
            name: `Tern`,
            message: `If you are so bored so did I hear that kissing burns 5 calories a minute. How about a workout? 😏`
        },
        {
            name: `Prowl`,
            message: `I don't know where to look! That temping ass or those beautiful eyes and kissable lips. I'm being pulled in so many directions!`
        },
        {
            name: `Suricat`,
            message: `I hear people without any clothes are 5 times less likely to be bored...`
        },
        {
            name: `Sarcasmo`,
            message: `More like Bummed out`
        },

    ],
    "Ann24": [
        {
            name: ann.properties.instaNickName,
            message: `Hey guys! What do you think about this look? Do you like it? 😊`,
        },
        {
            name: `Prowl`,
            message: `I love it! Now I'll have something to hold on to.`
        },
        {
            name: `getoutofmylab`,
            message: `I can ride my Ann with some handlebars....some handlebars...some handlebars`
        },
        {
            name: `Adar`,
            message: `Eh, this look would fit @${alex.properties.instaNickName} better. But, to be fair, everything would.`
        },
        {
            name: `Adar`,
            message: `@${alex.properties.instaNickName} is just better.`
        },
        {
            name: `Dr.Pancakes`,
            message: `@Adar, there is really only one way for us to know for sure. @Sweet_Ann and @${alex.properties.instaNickName} we need you both to wear your like this together.`
        },
        {
            name: `CorprealFale`,
            message: `Cute! But need to see it from the back!`
        },
        {
            name: `Sarcasmo`,
            message: `Nice composition, although I do wonder what is the complete word behind the ‘ANN’ you are obscuring`
        },
        {
            name: `ruff_ryder`,
            message: `MAN you look gorgeous!`
        },

    ],
    "Ann23": [
        {
            name: ann.properties.instaNickName,
            message: `Photoshoot! thanks @${alex.properties.instaNickName} it was so much fun! 😘😘😘`,
        },
        {
            name: `lil_crazy_alex`,
            message: `I'm in love with that asssssss! 🍑🍑🍑`
        },
        {
            name: `CorprealFale`,
            message: `I'd love if you were kneeling infront of me 😍`
        },
        {
            name: `Prowl`,
            message: `I think this beautiful temptress is where the term "A lady in the streets and a freak in the sheets" comes from.`
        },
        {
            name: `Dr.pancakes`,
            message: `@sweet_ann Your page needs to come with a warning label. *May cause sudden hart palpations.*`
        },
        {
            name: `yougiblue`,
            message: `Mommy ❤️ waiting to see you with a Nigerian prince who will take you for a ride 😏`
        },
        {
            name: `Sarcasmo`,
            message: `To quote Al Pacino... "She's got a... **GREAT ASS**"`
        },
        {
            name: `NTRman`,
            message: `breathtaking ❤️‍🔥 ❤️‍🔥 ❤️‍🔥`
        },
        {
            name: `Ruff_ryder`,
            message: `Since you're on your knees already how 'bout we finish it off?`
        },
        {
            name: `Addar`,
            message: `Sweetie, you look both whorish and malnourished. I hope this is the last time you are wasting @${alex.properties.instaNickName} time. You are destructive for her career.`
        },
        {
            name: `Harry_P`,
            message: `Words cannot adequately describe dat ass.`
        },

    ],
    "Ann22": [
        {
            name: ann.properties.instaNickName,
            message: `He fell asleep and I'm bored`,
        },
        {
            name: alex.properties.instaNickName,
            message: `@${ann.properties.instaNickName} Kinky!!! 😳 What were you doing??? Huhh??? 🍆❓❓❓`,
        },
        {
            name: `Yougi`,
            message: `How about a game of finding the sausage ?? 😏`,
        },
        {
            name: `Prowl`,
            message: `Sounds like just one may not be enough...`,
        },
        {
            name: `ruff_ryder`,
            message: `you can come to me for round 2-24. I got quite the stamina, if you cath my drift 😉`,
        },
        {
            name: `TeamPlayer`,
            message: `Say AHHHHHH @${ann.properties.instaNickName}`,
        },
        {
            name: `Tomcat`,
            message: `you can come be bored with me`,
        },
        {
            name: `TheAgent`,
            message: `${ann.properties.instaNickName} i can hook you up with some primo roles DM your portfolio and let's get busy making you a star!`,
        },
        {
            name: `war`,
            message: `Come over and I'll blow your mind after you blow me`,
        },
        {
            name: `4DoorsMoreWhores`,
            message: `What do you say we slip into a room....and you two split me open like a coconut?`,
        },

    ],
    "Ann21": [
        {
            name: ann.properties.instaNickName,
            message: `Getting naughty at the bar after closing hours 😜!`,
        },
        {
            name: "Prowl",
            message: "May I get naughty with you?"
        },
        {
            name: "DR.PANCAKES",
            message: "Why wait till closing time? 😏"
        },
        {
            name: "Suricat",
            message: "This new waitress sure deserves all the tips !"
        },
        {
            name: "CorprealFale",
            message: "Bodyshots on the menu? 😉"
        },
        {
            name: "JeanB",
            message: "after the bar foreplay how about you come to my place for the main act ❤️‍🔥"
        },
        {
            name: "getoutofmylab",
            message: "girl, you give love a plaid name."
        },
        {
            name: "KyD",
            message: "there will be an increase in the bar takings 😋"
        },
        {
            name: "Harry_Potter",
            message: "holy shit!  Can I buy you a butter beer?"
        },
        {
            name: "Arthur",
            message: "Ann you look great, but you should not expose yourself like that. Others can get the wrong idea."
        },

    ],
    "Ann20": [
        {
            name: ann.properties.instaNickName,
            message: `Someone told me that's my best angle 🤔😛`,
        },
        {
            name: `Prowl`,
            message: `When a woman sticks out her ass like that with that look in her eyes, can you really resist?`,
        },
        {
            name: `ruff_ryder`,
            message: `I eat ass. I'm just gonna leave that here 😎 😘`,
        },
        {
            name: `Dr.Pancakes`,
            message: `@Prowl We are all powerless under her influence...`,
        },
        {
            name: `scooterb`,
            message: `The doctor is right! #goddess #nextstar`,
        },
        {
            name: `009`,
            message: `can I stick my meat between those buns`,
        },

    ],
    "Ann19": [
        {
            name: ann.properties.instaNickName,
            message: `What happens in an alley stays in the alley 😂`,
        },
        {
            name: `Prowl`,
            message: `So hot, even the graffiti wants to kiss it.`,
        },
        {
            name: `scooterb`,
            message: `indeed @Prowl - what a rush! #limelight`,
        },
        {
            name: `009`,
            message: `would love to take a bite of that apple`,
        },

    ],
    "Ann18": [
        {
            name: ann.properties.instaNickName,
            message: `A cool grafity we found in some random alley`,
        },
        {
            name: `ruff_ryder`,
            message: `"RUSH"... yeah that fits pretty nicely 'cause I'm rushing to take you home and take them clothes OFF!`,
        },
        {
            name: `Prowl`,
            message: `@ruff_ryder I see what you did there 😉 No really can I watch.`,
        },
        {
            name: `Dr.Pancakes`,
            message: `@ruff_ryder I'm not sure what Canada's greatest rock band has to to do with this pic. However I do like the clothes off part. 🤓`,
        },
        {
            name: `ruff_ryder`,
            message: `@Prowl Be my guest. You can look but you can't touch... Seriously, one wrong move and I'mma knock you out.`,
        },

    ],
    "Ann17": [
        {
            name: ann.properties.instaNickName,
            message: `Believe it or not but I don't know these guys 😅`,
        },
        {
            name: `Prowl`,
            message: `The queen reining from her throne.`,
        },
        {
            name: `TeamPlayer`,
            message: `put me in coach im ready to play with @${ann.properties.instaNickName} #tagteam #drivetothehoop`,
        },
        {
            name: `PureGuy`,
            message: `so many possibilities here.`,
        },

    ],
    "Ann16": [
        {
            name: ann.properties.instaNickName,
            message: `I'm popular!`,
        },
        {
            name: `Prowl`,
            message: `Wait for it. Any second now they are going to start "The Macarena" 😃`,
        },
        {
            name: `PureGuy`,
            message: `I can almost see an Oreo`,
        },
        {
            name: `TheAgent`,
            message: `${ann.properties.instaNickName} not sure who is taking these shots but they don't really know what they are doing. Let's talk!`,
        },

    ],
    "Ann15": [
        {
            name: ann.properties.instaNickName,
            message: `What do you think about this angle? 😋`,
        },
        {
            name: `Prowl`,
            message: `I said hands against the wall mam and spread em!`,
        },
        {
            name: `Dr.Pancakes - `,
            message: `${ann.properties.instaNickName} I'm not so sure about those shorts, need to see them form another angle. 🤔`,
        },
        {
            name: `scooterb`,
            message: `looking lovely! btw when will be get more posts of you and @${alex.properties.instaNickName} together??? you both look hot!`,
        },
        {
            name: `Blackbeard`,
            message: `I just can't get enough of this pics! Are you considering selling them or something? Because I'll open my wallet at the speed of light`,
        },

    ],
    "Ann14": [
        {
            name: ann.properties.instaNickName,
            message: `I love this one! What do you guys think? 💖💖💖`,
        },
        {
            name: `Prowl`,
            message: `Is the graffiti in the background using a pen or about to do a line of blow? Speaking of blow...`,
        },
        {
            name: `TeamPlayer`,
            message: `${ann.properties.instaNickName} you lookin lonely.  want to meet me and boys later for a good time?`,
        },
        {
            name: `scooterb`,
            message: `@TeamPlayer bruh come on`,
        },

    ],
    "Ann13": [
        {
            name: ann.properties.instaNickName,
            message: `I can't believe ${mc.name} convinced doing that! I got caught and was called a slut 😞`,
        },
        {
            name: `Prowl`,
            message: `That outfit looks even better from the back🤤`,
        },
        {
            name: `scooterb`,
            message: `${ann.properties.instaNickName} looking good!  i think you'll be a natural at acting! 🤩`,
        },
        {
            name: `TeamPlayer`,
            message: `@scooterb yep already got her lined up for an audition! #castingcouch #calendargirl`,
        },

    ],
    "Ann12": [
        {
            name: ann.properties.instaNickName,
            message: `I know the jeans are short... But I love it! Don't judge! 😚`,
        },
        {
            name: `Prowl`,
            message: `Are you peaking over my fence again?`,
        },
        {
            name: `alexforever`,
            message: `${ann.properties.instaNickName} so happy i found you!!! had seen u on @${alex.properties.instaNickName}'s Insta! I love those heels!!! you both have such great taste! 🥰`,
        },

    ],
    "Ann10": [
        {
            name: ann.properties.instaNickName,
            message: `The outfit actually burst open after this pic 🤭`,
        },
        {
            name: `Prowl`,
            message: `Breaking News Update: She has now moved to the bed. Outfit is barely hanging on.`,
        },
        {
            name: `TheAgent`,
            message: `${ann.properties.instaNickName} i know talent when i see it.  Lets make u famous! DM me your details!`,
        },
        {
            name: `the_collector`,
            message: `DM me the other image please @${ann.properties.instaNickName}`,
        },



    ],
    "Ann9": [
        {
            name: ann.properties.instaNickName,
            message: `Trying to be sexy but t looks like I passed out.\nThis one is so revealing I was staring at the screen before clicking the submit button 😌`,
        },
        {
            name: `Yougi`,
            message: `If I'd wish to be an object, I'd be this bed ❤️`,
        },
        {
            name: `ruff_ryder`,
            message: `@Prowl She is the living dream.`,
        },
        {
            name: `Dr.Pancakes`,
            message: `@Prowl If she is only a dream, don't wake me up.`,
        },
        {
            name: `scooterb`,
            message: `x marks the spot.....s......`,
        },
        {
            name: `009`,
            message: `is it weird I wanna sniff your armpits 😋`,
        },


    ],
    "Ann8": [
        {
            name: ann.properties.instaNickName,
            message: `What do you think about the new outfit my bf got for me?😊`,
        },
        {
            name: `Yougi`,
            message: `Oi how does it look like without the bandages ???`,
        },
        {
            name: `Prowl`,
            message: `Breaking News! Hot girl poses for Insta!`,
        },
        {
            name: `ruff_ryder`,
            message: `my eyes are just like the bandages on your breasts 'cause your looks just killed me for real.`,
        },
        {
            name: `Dr.Pancakes`,
            message: `Proof that angels do exist.`,
        },
        {
            name: `Alexforever`,
            message: `${ann.properties.instaNickName} you look so pretty!`,
        },

    ],
    "Ann7": [
        {
            name: ann.properties.instaNickName,
            message: `Thanks for the photo! @${alex.properties.instaNickName} 😘`,
        },
        {
            name: alex.properties.instaNickName,
            message: `it was fun! We should do it more often @${ann.properties.instaNickName} 😘😘😘`,
        },

    ],
    "Ann6": [
        {
            name: ann.properties.instaNickName,
            message: `We couldn't get in but we've met ALEX!!!`,
        },
        {
            name: alex.properties.instaNickName,
            message: `That's right! XOXOXO @${ann.properties.instaNickName} 😘😘😘`,
        },

    ],
    "Ann5": [
        {
            name: ann.properties.instaNickName,
            message: `My sister wanted to take a picture of me in a stupid position so I let her lol!`,
        },

    ],
    "Ann4": [
        {
            name: ann.properties.instaNickName,
            message: `Getting ready and heading to the movies!!! #excited #happy #movies`,
        },

    ],
    "Ann3": [
        {
            name: ann.properties.instaNickName,
            message: `On my way home`,
        },
        {
            name: alex.properties.instaNickName,
            message: `@${ann.properties.instaNickName} HOT HOT HOT!!! 😍😍😍`,
        },
    ],
    "Ann2": [
        {
            name: ann.properties.instaNickName,
            message: `Getting ready for Joe's birthday party! It's been a long time since I went out with more than one friend! :)`,
        },

        {
            name: alex.properties.instaNickName,
            message: `@${ann.properties.instaNickName} 😲😲😲 Who's Joey??? 👅👉🍆???????`,
        },
        {
            name: ann.properties.instaNickName,
            message: `@${alex.properties.instaNickName} OMG Alex!! He is Vanessa's boyfriend.`,
        },
        {
            name: alex.properties.instaNickName,
            message: `@${ann.properties.instaNickName} 😲😲😲 Who's Vanessa??? 👅👉🐱???????`,
        },
        {
            name: ann.properties.instaNickName,
            message: `🤦‍♀️`,
        },
    ],
    "Ann1": [
        {
            name: ann.properties.instaNickName,
            message: `So I got bored enough to open Insta...`
        },
        {
            name: alex.properties.instaNickName,
            message: `Finally!!! @${ann.properties.instaNickName} 😘😘😘`
        },
    ],

};
